/* eslint-disable */

export const CommerceDecisionStatus = {
  Allowed: 'allowed',
  Blocked: 'blocked',
  AuthenticationRequired: 'authentication_required'
} as const;
export type CommerceDecisionStatus = typeof CommerceDecisionStatus[keyof typeof CommerceDecisionStatus];
